import { logger } from '@app/logger';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { marketingSourceService } from './MarketingSourceService';
import { MarketingData } from './_private/types';

/**
 * Gets marketing data, may return null marketing data in case failure
 * returns or feature flag is not enabled.
 */
export async function maybeGetMarketingData(): Promise< { marketing: MarketingData | Record<string, never> | null } > {
    try {
        const shouldSendMarketingData = await featureFlagService.getFeatureValue('growth.should-send-marketing-on-deposit', false);
        if (!shouldSendMarketingData) {
            return { marketing: null };
        }

        return { marketing: marketingSourceService.getMarketingData() };
    } catch (error) {
        logger.error(error as Error);
        return { marketing: null };
    }
}
